import React from 'react';
import { C } from '../../shared/design-tokens.js';

export function currentWeekStartIso(): string {
  const now = new Date();
  const local = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const day = local.getDay();
  const diff = local.getDate() - day + (day >= 6 ? 0 : -1);
  const weekStart = new Date(local);
  weekStart.setDate(diff);
  return weekStart.toISOString().split('T')[0];
}

export const CONTROL_INPUT: React.CSSProperties = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: 8,
  border: `1px solid ${C.borderSoft}`,
  background: 'rgba(7, 11, 18, 0.72)',
  color: C.text,
  fontSize: 14,
  boxSizing: 'border-box',
};

export const MUTED_LABEL: React.CSSProperties = {
  display: 'block',
  color: C.textMuted,
  fontSize: 12,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginBottom: 6,
};

interface Nameable {
  first_name?: string;
  last_name?: string;
}

export function sortByName(a: Nameable, b: Nameable): number {
  return `${a.first_name || ''} ${a.last_name || ''}`.localeCompare(`${b.first_name || ''} ${b.last_name || ''}`);
}

export function requestTypeLabel(value: string | null | undefined): string {
  return String(value || 'request').replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}
